import classNames from 'classnames';
import React from 'react';
import { Detector } from 'react-detect-offline';
import { useTranslation } from 'react-i18next';
import { AttentionIcon } from '../adhara/icons/CommonIcons.js';
import ButtonPrimary from '../buttons/ButtonPrimary.js';
import ShadowCard from '../card/ShadowCard.js';
import styles from './NetworkDetector.module.css';

const NetworkDetector = () => {
  const { t } = useTranslation();

  return (
    <Detector
      render={({ online }) => (
        <ShadowCard
          className={classNames(styles.detector, { [styles.online]: online })}
        >
          <div className={styles.icon}>
            <AttentionIcon />
          </div>
          <div className={styles.info}>
            <h3>{t('popup.unstable_connection_title')}</h3>
            <p>{t('popup.unstable_connection_message')}</p>
            <ButtonPrimary onClick={() => window.location.reload(false)}>
              {t('popup.refresh_button')}
            </ButtonPrimary>
          </div>
        </ShadowCard>
      )}
      polling={{ url: '/ping' }}
    ></Detector>
  );
};

export default NetworkDetector;
